module.exports = __webpack_public_path__ + "img/IMAGE3MESINOFFSET.ef6d9396.jpeg";